import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import React from 'react';
import styles from '../Style/DatasetInfo.module.scss';

export function BuyButton(props: {
  id: string;
  addedToCart: boolean;
  addToCart: () => void;
  removeFromCart: () => void;
  cartLoading: boolean;
  hasDatasets: boolean;
  disabled: boolean;
}) {
  return (
    <>
      {props.addedToCart ? (
        <Button
          type="primary"
          className={styles.CartButton}
          onClick={props.removeFromCart}
          loading={props.cartLoading}
          disabled={!props.hasDatasets}
          style={{
            width: '100px'
          }}
        >
          Remove
        </Button>
      ) : (
        <Button
          id={`PointPanel-AddToCart_Button_${props.id}`}
          type="primary"
          className={styles.CartButton}
          onClick={props.addToCart}
          loading={props.cartLoading}
          disabled={!props.hasDatasets || props.disabled}
          style={{
            width: '100px'
          }}
        >
          <Space>
            Add to Cart
          </Space>
        </Button>
      )}
    </>
  );
}

export function DownloadButton(props: {
  showCancelDownloadButton: boolean;
  startDownloadProcess: () => void;
  disableDownloadButtons: boolean;
  handleCancelDownload: () => void;
  id: string;
}) {
  return (
    <>
      {!props.showCancelDownloadButton ? (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            id={`PointPanel-Download_Button_${props.id}`}
            type="primary"
            className={styles.CartButton}
            onClick={() => props.startDownloadProcess()}
            disabled={props.disableDownloadButtons}
            style={{
              width: '100px'
            }}
          >
            <Space>
              Download
              <DownloadOutlined />
            </Space>
          </Button>
        </div>
      ) : (
        <Button
          type="primary"
          danger
          icon={<LoadingOutlined />}
          className={styles.CartButton}
          onClick={() => props.handleCancelDownload()}
          style={{
            width: '100px'
          }}
        >
          Cancel
        </Button>
      )}
    </>
  );
}
